import React from "react";
import {
    Heading,
    FormControl,
    FormLabel,
    Button,
    Select,
    Text,
    Link,
    Stack,
    Box,
  } from '@chakra-ui/react'
import { LightBg, ParentCard, Card } from "./style";
import { useNavigate } from "react-router-dom";

const RegisterChooseRole = () => {
    let navigate = useNavigate();
    var role = "role"
    return (
        <>
        <LightBg>
            <ParentCard>
                <Card>
                    <Stack>
                        <Box>
                            <Heading paddingBottom={10} textAlign={'center'}>Daftar</Heading>
                        </Box>
                        <Box>
                            <FormControl id='peran' isRequired>
                            <FormLabel>Pilih peran</FormLabel>
                            <Select id="selectRole">
                                <option value='Pilih peran' disabled selected>Pilih peran</option>
                                <option value='peserta'>Peserta</option>
                                <option value='mitra'>Mitra</option>
                            </Select>
                            </FormControl>
                        </Box>
                        <Box align={'center'}>
                            <Button style={{background:'#6554C0', color:'#FFFFFF', justifyContent:'center'}} mt={4} type='submit'
                                onClick={() => {navigate("/register/"+document.getElementById("selectRole").value);}}>
                                    Selanjutnya
                            </Button>
                        </Box>
                        <Box>
                            <Text align={'center'}>Sudah punya akun? <Link href="/login" color={'blue.400'}>Masuk</Link></Text>
                        </Box>
                    </Stack>
                </Card>
            </ParentCard>
        </LightBg>
        </>
    );
}


export default RegisterChooseRole;